<div class="arcade-shell">
	<div class="arcade-marquee" aria-hidden="true">
		<span class="marquee-text">{{ title }}</span>
	</div>

	<div
		class="minesweeper-root"
		tabindex="0"
		role="application"
		aria-label="Minesweeper game"
	>
		<div class="hud-row" aria-live="polite">
			<div class="hud-chip">
				<span class="hud-label">Time</span>
				<span class="hud-value">{{ timer }}s</span>
			</div>
			<div class="hud-chip">
				<span class="hud-label">Flags</span>
				<span class="hud-value">{{ flagsRemaining }}</span>
			</div>
			<div class="hud-chip">
				<span class="hud-label">Mines</span>
				<span class="hud-value">{{ mines }}</span>
			</div>
			<div class="hud-chip hud-chip--grow">
				<span class="hud-label">Status</span>
				<span class="hud-value hud-value--small">{{ gameStatus }}</span>
			</div>
		</div>

		<div class="controls-row">
			<div class="difficulty-row" aria-label="Difficulty">
				<button
					type="button"
					class="chip-btn"
					*ngFor="let preset of difficulties"
					[class.chip-btn--active]="selectedDifficulty === preset.id"
					(click)="setDifficulty(preset.id)"
				>
					{{ preset.label }}
				</button>
			</div>
			<button type="button" class="action-btn" (click)="restartGame()">New Game</button>
		</div>

		<div class="board-wrap" [style.--ms-cols]="cols">
			<div class="grid" *ngIf="grid">
				<div *ngFor="let row of grid; let rowIndex = index" class="row">
					<div
						*ngFor="let cell of row; let colIndex = index"
						class="cell"
						[class.revealed]="cell.revealed"
						[class.mine]="cell.revealed && cell.mine"
						[class.flagged]="cell.flagged && !cell.revealed"
						[class.num-1]="cell.revealed && cell.adjacentMines === 1"
						[class.num-2]="cell.revealed && cell.adjacentMines === 2"
						[class.num-3]="cell.revealed && cell.adjacentMines === 3"
						[class.num-4]="cell.revealed && cell.adjacentMines === 4"
						[class.num-5]="cell.revealed && cell.adjacentMines === 5"
						[class.num-6]="cell.revealed && cell.adjacentMines === 6"
						[class.num-7]="cell.revealed && cell.adjacentMines === 7"
						[class.num-8]="cell.revealed && cell.adjacentMines === 8"
						role="button"
						tabindex="0"
						[attr.aria-label]="cell.flagged ? 'Flagged cell, row ' + (rowIndex + 1) + ', column ' + (colIndex + 1) : 'Cell row ' + (rowIndex + 1) + ', column ' + (colIndex + 1)"
						(click)="revealCell(rowIndex, colIndex)"
						(contextmenu)="toggleFlag(rowIndex, colIndex, $event)"
						(keydown)="onCellKeyDown(rowIndex, colIndex, $event)"
					>
						<span *ngIf="cell.flagged && !cell.revealed" class="cell-flag" aria-hidden="true">⚑</span>
						<span *ngIf="cell.revealed && cell.mine" class="cell-mine" aria-hidden="true">✱</span>
						<span *ngIf="cell.revealed && cell.adjacentMines > 0 && !cell.mine">
							{{ cell.adjacentMines }}
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
